export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Tmobile/theme/components/scorecard/MetricsLabels/index.js